import {getGPUTier} from "detect-gpu";

export const device = () => {
    let device = "desktop"
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Windows Phone/i.test(navigator.userAgent)) {
        device = "mobile";
    }
    return device
}


export const matchedMedia = () => {
    const matchedMedia = matchMedia('(prefers-reduced-motion: no-preference)');
    return matchedMedia.matches;
}


export const gpuTier = async () => {
    return await getGPUTier().then(r => {
        const {tier, device, gpu, fps, isMobile} = r
        return {tier, device, gpu, fps, isMobile}
    })
}
